// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"vendors-node_modules_cross-fetch_dist_browser-ponyfill_js-node_modules_graphql-tag_lib_index_-9fa6fc":"98f804f2","src_exports_AuthSource_AuthSource_ts":"f19a25b6","src_exports_SearchInput_SearchInput_tsx":"c006eb3c"}[chunkId] + ".chunk.js";
};